export default __webpack_public_path__ + "static/media/teatro.1c0cc32f.jpg";